export function stripHTMLTags(str: string): string {
  return str.replace(/(<([^>]+)>)/gi, '');
}
